import React, { useEffect, useState } from "react";
import { Plus, Trash2, CalendarDays } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PageHeader, Card, Loading, Modal, EmptyState } from "../components/ui";

export default function Holidays() {
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", date: "" });
  const canManage = ["SUPERADMIN", "HR_ADMIN"].includes(user?.role);

  const load = () => api.get("/holidays").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);
  const add = async (e) => { e.preventDefault(); await api.post("/holidays", form); setOpen(false); setForm({ name: "", date: "" }); load(); };
  const del = async (id) => { if (window.confirm("Delete holiday?")) { await api.delete(`/holidays/${id}`); load(); } };
  if (!items) return <Loading />;

  return (
    <div>
      <PageHeader title="Holidays" subtitle={`${items.length} company holidays`}>
        {canManage && <button data-testid="add-holiday" onClick={() => setOpen(true)} className="btn-accent"><Plus size={16} /> Add Holiday</button>}
      </PageHeader>
      {items.length === 0 ? <EmptyState icon={CalendarDays} title="No holidays configured" /> : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((h) => (
            <Card key={h.id} interactive className="flex items-center gap-4 p-5" data-testid={`holiday-${h.id}`}>
              <div className="flex h-14 w-14 flex-col items-center justify-center rounded-lg bg-accent/10 text-accent">
                <span className="font-head text-lg font-extrabold">{new Date(h.date).getDate()}</span>
                <span className="text-[10px] font-semibold uppercase">{new Date(h.date).toLocaleString("en", { month: "short" })}</span>
              </div>
              <div className="flex-1">
                <p className="font-semibold text-slate-800 dark:text-slate-100">{h.name}</p>
                <p className="text-xs text-slate-400">{new Date(h.date).toLocaleDateString("en-IN", { weekday: "long" })}</p>
              </div>
              {canManage && <button onClick={() => del(h.id)} className="text-slate-300 hover:text-red-500"><Trash2 size={16} /></button>}
            </Card>
          ))}
        </div>
      )}
      <Modal open={open} onClose={() => setOpen(false)} title="Add Holiday"
        footer={<><button onClick={() => setOpen(false)} className="btn-outline">Cancel</button><button form="hol-form" className="btn-accent">Add</button></>}>
        <form id="hol-form" onSubmit={add} className="space-y-4">
          <div><label className="label">Name *</label><input required data-testid="holiday-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input" /></div>
          <div><label className="label">Date *</label><input required type="date" data-testid="holiday-date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} className="input" /></div>
        </form>
      </Modal>
    </div>
  );
}
